import React from "react";
import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";

import Login from "./pages/Login";
import EsqueciSenha from "./pages/Login/EsqueciSenha";
import NovaSenha from "./pages/Login/NovaSenha";
import Registro from "./pages/Registro";

import AdminLayout from "./painel/layout/Admin";

export default function Router() {
  return (
    <BrowserRouter>
      <Switch>

        <Route path="/"  exact component={AdminLayout} />
        <Route path="/dashboard"  component={AdminLayout} />
        
        <Route path="/login" exact component={Login} />
        <Route path="/esqueci-senha" exact component={EsqueciSenha} />
        <Route path="/redefinir-senha" exact component={NovaSenha} />
        <Route path="/registro" exact component={Registro} />
      </Switch>
    </BrowserRouter>
  );
}
